import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, } from 'react-bootstrap';

//components//
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import TripleTexWidget from './integrations/TripleTex.js'
import VismaWidget from './integrations/Visma.js'
import XledgerWidget from './integrations/Xledger.js'

//elements//
import Select from '../../../../elements/Select.js';

//utils//
import { payrollIntegrationOptions } from '../../../../utils/constants.js';

//assets//
import TripleTexLogo from '../../../../assets/img/tripletex_logo.svg';
import VismaLogo from '../../../../assets/img/visma_logo.png';
import XledgerLogo from '../../../../assets/img/xledger_logo.png';
import DnbLogo from '../../../../assets/img/dnb_logo.svg';


//constants//
const payrollProductOptions = [
    { value: payrollIntegrationOptions.VISMA, label: 'Visma', image: VismaLogo },
    { value: payrollIntegrationOptions.TRIPLETEX, label: 'TripleTex', image: TripleTexLogo },
    { value: payrollIntegrationOptions.XLEDGER, label: 'Xledger', image: XledgerLogo },
    { value: payrollIntegrationOptions.DNBREGNSKAP, label: 'DnBregnskap', image: DnbLogo },
]


const preparePayrollOptions = () => {
    return payrollProductOptions.map(item => ({
        label: item.image ? (
            <div className='d-flex align-items-center'>
                <img src={item.image} height="30px" width="30px" alt='integration-logo'/>
                <div className='ml-10'>{item.label}</div>
            </div>
        )
            : <div>{item.label}</div>,
        value: item.value
    }));
}
class PayrollIntegrations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payrollProduct: this.props.clientStore.currentEntity?.client?.integration_details?.product
        }
    }

    handleChange = (evt) => {
        this.setState({ payrollProduct: evt })
    }

    handleDropDown = (payrollProduct) => {
        switch (payrollProduct) {
            case payrollIntegrationOptions.TRIPLETEX:
                return <TripleTexWidget payrollProduct={payrollProduct} handleSubTabChange={this.props.handleSubTabChange}/>
            case payrollIntegrationOptions.DNBREGNSKAP:
                return (<div className='d-flex justify-content-center mt-5 fw-bold text-primary font-size-25'>{this.props.t('Coming Soon')}...</div>)
            case payrollIntegrationOptions.VISMA:
                return <VismaWidget payrollProduct={payrollProduct} handleSubTabChange={this.props.handleSubTabChange}/>
            case payrollIntegrationOptions.XLEDGER:
                return <XledgerWidget payrollProduct={payrollProduct} handleSubTabChange={this.props.handleSubTabChange}/>
            default:
                return (<div className='d-flex justify-content-center mt-5 fw-bold text-primary font-size-25'>{this.props.t('Please Select which integration you want to use')}</div>)
        }
    }

    render() {
        const { payrollProduct } = this.state
        return (
            <div>
                <Col xs={12} sm={4}>
                    <label className="control-label">{this.props.t('Payroll Product')}</label>
                    <Select
                        options={preparePayrollOptions()}
                        value={payrollProductOptions.find(item => item.value === payrollProduct)}
                        onChange={evt => this.handleChange(evt.value)}
                        style={{ width: '100%' }}
                    />
                </Col>
                {this.handleDropDown(payrollProduct)}
            </div>
        );
    }
}
export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(PayrollIntegrations))));